import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  input,
  OnInit,
  output,
  Output,
  QueryList,
  viewChild,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { MenuItem } from '../../models/menu-item.interface';
import { MatMenu, MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MenuTrigger } from '../../models/menu-trigger.interface';
import { AsyncPipe } from '@angular/common';
import { CecBreakpointPipe } from 'src/app/controls/pipes/cec-breakpoint.pipe';

@Component({
  selector: 'cec-menu>cec-menu-item,cec-menu-item>cec-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss'],
  standalone: true,
  imports: [
    MatMenuModule,
    MatIconModule,
    TranslateModule,
    MatIconModule,
    MatMenuModule,
    MatDividerModule,
    MatExpansionModule,
    MatButtonModule,
    MatListModule,
    AsyncPipe,
    CecBreakpointPipe,
  ],
})
export class MenuItemComponent implements AfterViewInit {
  /** Menu component reference */
  menu = viewChild<MatMenu>(MatMenu);

  /** Item items reference */
  items = input<MenuItem[]>(undefined);

  /** Root item reference */
  rootItem = input<MenuItem>(undefined);

  /** Menu alignment reference */
  alignment = input<'left' | 'right'>('left');

  /** Button click item output emitter */
  onItemClicked = output<MenuTrigger>();

  /** Menu trigger emitter reference */
  onReturnTrigger = output<MatMenu>();

  /** Change detector reference */
  private cdr = inject(ChangeDetectorRef);

  /** Obtained menu triggers reference */
  protected obtainedMenus: Record<string, MatMenu> = {};

  ngAfterViewInit(): void {
    /** if menu is not present, do not emit */
    if (this.menu()) {
      this.onReturnTrigger.emit(this.menu());
    }
  }

  /**
   * Emits the click on desired item
   * @param item the clicked item
   * @param rootItem the clicked root item
   */
  protected onClickItem(item: MenuItem, rootItem: MenuItem): void {
    this.onItemClicked.emit({
      item: item,
      rootItem: rootItem,
    });
  }

  /**
   * Emits the click on desired sub item
   * @param trigger the menu trigger
   */
  protected onClickSubItem(trigger: MenuTrigger): void {
    this.onItemClicked.emit(trigger);
  }

  /**
   * Sets the obtained menu triggers
   * @param menuTrigger the menu trigger to set
   * @param index the trigger index
   */
  protected onTrigger(menuTrigger: MatMenu, index: string): void {
    /** sets the menu trigger */
    this.obtainedMenus[index] = menuTrigger;

    /** detects the changes */
    this.cdr.detectChanges();
  }
}
